import Message from 'shared_components/message';
import { API_GET_METHOD, API_PUT_METHOD, API_POST_METHOD } from 'global_config/constant-global';
import { axiosLabAPI } from '../axios';
import { showMessage } from 'services/settings/message';

export async function fetchPerSpecimens(selectedSection) {
	let specimens = [];
	const params = {p_ids: selectedSection}

	try {
		const url = `settings/examrequestpersection`;

		const response = await axiosLabAPI({ method: API_GET_METHOD, url, params});
		const { data } = await response;

		specimens = data.RECORDS.at(0).perSpecimen;
	} catch (e) {
		const status = (e.response && e.response.status) || 500;
		// showMessage(status);
		showMessage(e);
	}

	return specimens;
}

export async function fetchExamRequests(sectionId, specimenId, searchValue = '', silentFlag = false) {
	let examRequests = [];

	try {
		// const url = `lab/ExamRequest/Settings/SectionID/${sectionId}/SpecimenID/${specimenId}`;
		const url ='settings/examrequest';
		const params = {
			p_section_id: sectionId,
			p_specimen_id: specimenId,
			p_search_value: searchValue
		}

		const response = await axiosLabAPI({ method: API_GET_METHOD, url, params });
		const { data } = await response;

		examRequests = data.RECORDS || [];
	} catch (e) {
		if(!silentFlag){
			showMessage(e);
		}
	}

	return examRequests;
}

export async function fetchSelectedExamList(secID, specID, erID) {
	let examList = [];

	try {
		const content = {
			method: 'GET',
			url: `settings/examrequest`,
			params:{
				p_section_id: secID,
				p_specimen_id: specID,
				p_exam_request_id: erID
			}

		};

		const response = await axiosLabAPI(content);
		const { data } = await response;

		examList = data.RECORDS.at(0) || [];
	} catch (e) {
		// const status = (e.response && e.response.status) || 500;
		// showMessage(status);
		showMessage(e);
	}

	return examList;
}

export async function fetchExamRequestList() {
	let data = null;

	try {
		const resp = await axiosLabAPI({
			method: API_GET_METHOD,
			url: 'settings/examrequest',
		});

		data = resp.data.RECORDS || [];
	} catch (e) {
		const status = (e.response && e.response.status) || 500;
		// showMessage(status);
		showMessage(e);
	}
	return data;
}

export async function updateExamRequest(examRequest) {
	let updatedExamRequest = null;

	const { 
		sectionID,
		specimenID,
		examRequestID,
		examRequestCode,
		examRequestIntegrationCode,
		examRequestLoinc,
		examRequestName,
		examRequestSort,
		examRequestReportTemplate,
		examItems,
		examRequestActive,
		examRequestAnalyzerCodes,
		examRequestAutoSTAT,
		examRequestAutoSendOut
	} = examRequest;

	try {
		const content = {
			method: API_PUT_METHOD,
			url: 'settings/examrequest',
				data: {
				p_exam_request_id: examRequestID,
				p_exam_request_name: examRequestName,
				p_exam_request_code: examRequestCode,
				p_exam_request_loinc: examRequestLoinc,
				p_exam_request_integration_code: examRequestIntegrationCode,
				p_exam_request_sort: examRequestSort,
				p_section_id: sectionID,
				p_specimen_id: specimenID,
				p_exam_request_report_template: examRequestReportTemplate,
				p_exam_request_auto_send_out: examRequestAutoSendOut,
				p_exam_request_auto_stat: examRequestAutoSTAT,
				p_exam_request_is_active: examRequestActive,
				p_exam_request_values_array: JSON.stringify(examItems),
				p_exam_request_analyzer_codes_array: JSON.stringify(examRequestAnalyzerCodes),
			}
		};

		const response = await axiosLabAPI(content);
		const { data } = await response;

		updatedExamRequest = data;
	} catch (e) {
		const status = (e.response && e.response.status) || 500;
		// showMessage(status);
		showMessage(e);
	}

	return updatedExamRequest;
}

export async function createExamRequest(examItem) {
	let createdExamItem = null;

	const { 
		sectionID,
		specimenID,
		examRequestCode,
		examRequestIntegrationCode,
		examRequestLoinc,
		examRequestName,
		examRequestSort,
		examRequestReportTemplate,
		examItems,
		examRequestActive,
		examRequestAnalyzerCodes,
		examRequestAutoSTAT,
		examRequestAutoSendOut
	} = examItem;

	try {
		const content = {
			method: API_POST_METHOD,
			url: 'settings/examrequest',
			data: {
				p_exam_request_name: examRequestName,
				p_exam_request_code: examRequestCode,
				p_exam_request_loinc: examRequestLoinc,
				p_exam_request_integration_code: examRequestIntegrationCode,
				p_exam_request_sort: examRequestSort,
				p_section_id: sectionID,
				p_specimen_id: specimenID,
				p_exam_request_report_template: examRequestReportTemplate,
				p_exam_request_auto_send_out: examRequestAutoSendOut,
				p_exam_request_auto_stat: examRequestAutoSTAT,
				p_exam_request_is_active: examRequestActive,
				p_exam_request_values_array: JSON.stringify(examItems),
				p_exam_request_analyzer_codes_array: JSON.stringify(examRequestAnalyzerCodes),
			}
		};

		const response = await axiosLabAPI(content);
		const { data } = await response;

		createdExamItem = data.RECORDS;
	} catch (e) {
		const status = (e.response && e.response.status) || 500;
		// showMessage(status);
		showMessage(e);
	}

	return createdExamItem;
}

export async function updateExamRequestSort(payload) {
	let updatedExamRequestSort = null;

	try {
		const content = {
			method: API_PUT_METHOD,
			url: 'settings/examrequestsort',
			data: {
				p_exam_request_sorting_array: payload
			} 
		};

		const response = await axiosLabAPI(content);
		const { data } = await response;

		updatedExamRequestSort = data;
	} catch (e) {
		const status = (e.response && e.response.status) || 500;
		showMessage(e);
	}

	return updatedExamRequestSort;
}